export enum RegistrationSteps {
  ACCOUNT_CREATION = '0',
  EMAIL_VERIFICATION = '1',
  PHONE_VERIFICATION = '2',
}
